<div class="activity-timeline" *ngIf="entries.length; else emptyState">
  <article class="activity-entry" *ngFor="let entry of entries">
    <div class="activity-entry__dot" [class.is-audit]="entry.kind === 'audit'"></div>
    <div class="activity-entry__content">
      <div class="activity-entry__header">
        <strong>{{ entry.title }}</strong>
        <small>{{ formatTimestamp(entry.createdAt) }}</small>
      </div>
      <div class="activity-entry__meta" *ngIf="entry.actor">
        {{ entry.actor }}
      </div>
      <div class="activity-entry__details" *ngIf="entry.details && (entry.details | json) !== '{}'">
        <span *ngFor="let line of formatDetails(entry.details)">{{ line }}</span>
      </div>
    </div>
  </article>
</div>

<ng-template #emptyState>
  <div class="activity-empty">Noch keine Aktivität vorhanden.</div>
</ng-template>
